import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from "../shared/user.service";
import { EmployeeDepositsService } from "../service/employee-deposits.service";
import { FormBuilder, FormGroup, NgForm, Validators } from "@angular/forms";
import { Form161FormalyService } from "../service/form161Formaly.service";
import {
  Form161Employee,
  Form161EmployeeFundInstitution,
  Form161Filter,
  Form161Header,
  Form161SaveContainer,
  FormalyStatus,
} from "../model/form161Formaly.model";
import { HttpErrorResponse } from "@angular/common/http";
import { FundinstitutionService } from "../service/fundinstitution.service";
import { Form161FormalyEmployeeComponent } from "../form161-formaly-employee/form161-formaly-employee.component";
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: "app-form161-formaly",
  templateUrl: "./form161-formaly.component.html",
  styleUrls: ["./form161-formaly.component.css"],
  providers: [ConfirmationService]
})
export class Form161FormalyComponent implements OnInit {
  @ViewChild(Form161FormalyEmployeeComponent) form161FormalyEmployeeComponent: Form161FormalyEmployeeComponent;

  enumFormalyStatus = FormalyStatus;

  userDetails: any;

  fundInstitutionsList: any[];

  msgs: any[] = [];

  employersList: any[] = [];

  employeesList: any[] = [];

  selectedCustomer: string = null;

  selectedEmployees: any[] = [];

  choseEmployer = false;

  dataForm161Header: Form161Header = null;

  dialogAddFundInstitutionVisible: boolean = false;

  sector3 = false;
  section3StatusClicked: number;

  isForm161Allowed: boolean = true;
  

  selectedFundinstitution: any = null;
  currentEmployeeForFundInstitutionAdd: Form161Employee = null;

  selectedRecordId: number = null;

  customerForm: FormGroup;

  get getTikNikuim(){return this.customerForm.get('TikNikuim').value;}
  get getCustomerCityName(){return this.customerForm.get('CustomerCityName').value;}
  get getCustomerAddress(){return this.customerForm.get('CustomerAddress').value;}
  get getCustomerContactPhone(){return this.customerForm.get('CustomerContactPhone').value;}
  get getCustomerContactMail(){return this.customerForm.get('CustomerContactMail').value;}
  get getCustomerSignIdentityNumber(){return this.customerForm.get('CustomerSignIdentityNumber').value;}
  get getCustomerSignFirstName(){return this.customerForm.get('CustomerSignFirstName').value;}
  get getCustomerSignLastName(){return this.customerForm.get('CustomerSignLastName').value;}
  get getCustomerSignCellPhone(){return this.customerForm.get('CustomerSignCellPhone').value;}
  get getCustomerSignPhone(){return this.customerForm.get('CustomerSignPhone').value;}
  get getCustomerSignMail(){return this.customerForm.get('CustomerSignMail').value;}
  get getCustomerAddressBuilding(){return this.customerForm.get('CustomerAddressBuilding').value;}
  get getCustomerZipCode(){return this.customerForm.get('CustomerZipCode').value;}
  get getCustomerMinimumDaysForEmployee(){return this.customerForm.get('CustomerMinimumDaysForEmployee').value;}

  constructor(
    private userService: UserService,
    private dataService: EmployeeDepositsService,
    private form161FormalyService: Form161FormalyService,
    private fundInsitutionService: FundinstitutionService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private confirmationService: ConfirmationService
  ) {}

  refillCustomerDataFromForm() {
    this.dataForm161Header.TikNikuim = this.getTikNikuim;
    this.dataForm161Header.CustomerCityName = this.getCustomerCityName;
    this.dataForm161Header.CustomerAddress = this.getCustomerAddress;
    this.dataForm161Header.CustomerContactPhone = '0523634366';             //this.getCustomerContactPhone;
    this.dataForm161Header.CustomerContactMail = 'ido@hspension.co.il';    //this.getCustomerContactMail;
    this.dataForm161Header.CustomerSignIdentityNumber = this.getCustomerSignIdentityNumber;
    this.dataForm161Header.CustomerSignFirstName = this.getCustomerSignFirstName;
    this.dataForm161Header.CustomerSignLastName = this.getCustomerSignLastName;
    this.dataForm161Header.CustomerSignCellPhone = this.getCustomerSignCellPhone;
    this.dataForm161Header.CustomerSignPhone = this.getCustomerSignPhone;
    this.dataForm161Header.CustomerSignMail = this.getCustomerSignMail;
    this.dataForm161Header.CustomerAddressBuilding = this.getCustomerAddressBuilding;
    this.dataForm161Header.CustomerContactCellPhone = "123123";
    this.dataForm161Header.CustomerZipCode = this.getCustomerZipCode;
    this.dataForm161Header.CustomerMinimumDaysForEmployee = this.getCustomerMinimumDaysForEmployee;  
  }

  setForm() {
    this.customerForm.patchValue({
      TikNikuim: this.dataForm161Header.TikNikuim,
      CustomerCityName: this.dataForm161Header.CustomerCityName,
      CustomerAddress: this.dataForm161Header.CustomerAddress,
      CustomerContactPhone: this.dataForm161Header.CustomerContactPhone,
      CustomerContactMail: this.dataForm161Header.CustomerContactMail,
      CustomerSignIdentityNumber: this.dataForm161Header.CustomerSignIdentityNumber,
      CustomerSignFirstName: this.dataForm161Header.CustomerSignFirstName,
      CustomerSignLastName: this.dataForm161Header.CustomerSignLastName,
      CustomerSignCellPhone: this.dataForm161Header.CustomerSignCellPhone,
      CustomerSignPhone: this.dataForm161Header.CustomerSignPhone,
      CustomerSignMail: this.dataForm161Header.CustomerSignMail,
      CustomerAddressBuilding: this.dataForm161Header.CustomerAddressBuilding,
      CustomerContactCellPhone: this.dataForm161Header.CustomerContactCellPhone,
      CustomerZipCode: this.dataForm161Header.CustomerZipCode,
      CustomerMinimumDaysForEmployee: this.dataForm161Header.CustomerMinimumDaysForEmployee,      
    });
  }

  ngOnInit() {

    this.customerForm = this.fb.group({
      TikNikuim: ['', [Validators.required, Validators.pattern]],
      CustomerCityName: ['', Validators.required],
      CustomerAddress: [''],
      CustomerContactPhone: ['', [Validators.required, Validators.pattern]],
      CustomerContactMail: ['', [Validators.required, Validators.email]],
      CustomerSignIdentityNumber: ['', [Validators.required, Validators.pattern]],
      CustomerSignFirstName: ['', Validators.required],
      CustomerSignLastName: ['', Validators.required],
      CustomerSignCellPhone: ['', [Validators.required, Validators.pattern]],
      CustomerSignPhone: ['', Validators.pattern],
      CustomerSignMail: ['', [Validators.required, Validators.email]],
      CustomerAddressBuilding: [''],
      CustomerZipCode: ['', Validators.pattern],
      CustomerMinimumDaysForEmployee: ['', [Validators.required]],
    });


    this.userService.getUserClaims().subscribe((response) => {
      this.userDetails = response;

      if (this.userDetails && (this.userDetails.ClientRoleSupport || this.userDetails.ClientRoleAdministration || this.userDetails.ClientRoleSemiAdministrator)) {
        this.isForm161Allowed = true;
        this.dataService.getCustomers().subscribe((result: any) => {
          this.employersList = result;
        },
        (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בקבלת רשימת מעסיקים');
        });
      } else {
        this.form161FormalyService.getIsForm161Allowed().subscribe((resultData) => {
          if (resultData) {
            this.isForm161Allowed = true;
            this.selectedCustomer = this.userDetails.CurrentCustomerIdentityNumber;
            this.getEmployersData(this.selectedCustomer);            
          } else {
            // not allowed to 161
            this.isForm161Allowed = false;
          }

        },
        (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בקבלת פרטי מעסיק');
        });
        
      }
    },
    (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'תקלה בקבלת פרטי משתמש');
    });


    

    this.getFundInstituitionsList();

    // load form data
    let paramFormId = Number(this.route.snapshot.paramMap.get("formId"));
    let paramRecordId = Number(this.route.snapshot.paramMap.get("recordId"));
    if (paramFormId) {
      this.form161FormalyService
        .GetFullForm(paramFormId, paramRecordId)
        .subscribe(
          (data: Form161Header) => {
            this.dataForm161Header = data;
            this.selectedCustomer = this.dataForm161Header.CustomerIdentityNumber;
            this.sector3 = true;
            this.setForm();
            if (paramRecordId) {
              let emp = this.dataForm161Header.Employees.find(
                (f) => f.RecordId == paramRecordId
              );
              if (emp) {
                window.setTimeout(() => this.selectEmployee(emp), 1000);
              }
            }
          },
          (err: HttpErrorResponse) => {
            this.showMessage("error", "", "תקלה בקבלת נתוני טופס ");
          }
        );
    }
  }

  getFundInstituitionsList(): any {
    this.form161FormalyService.getFundinstitution().subscribe(
      (result: any) => {
        this.fundInstitutionsList = result;
        // console.log('getFundInstituitionsList');
        // console.log(this.fundInstitutionsList);
      },
      (err: HttpErrorResponse) => {
        this.showMessage("error", "", "תקלה בקבלת רשימת קופות ");
      }
    );
  }

  onSubmitForm = (form: NgForm) => {
    let employerAndEmployeesData: Form161Filter = {
      CustomerIdentityNumber: this.selectedCustomer,
      Employees: form.value.employees,
    };

    //employerAndEmployeesData = form.value;

    //console.log(employerAndEmployeesData);

    this.form161FormalyService
      .getEmployeAndFundInstitutionsData(employerAndEmployeesData)
      .subscribe(
        (response: Form161Header) => {
          // console.log(response);

          this.dataForm161Header = response;
          this.dataForm161Header.CustomerMinimumDaysForEmployee = 21;
          this.setForm();
          //console.log(this.dataForm161Header);
        },
        (err: HttpErrorResponse) => {
          this.showMessage("error", "", "תקלה בקבלת נתונים עבור העובד שהוזן");
        }
      );
  };

  getEmployersData = (selectedCustomer: string) => {
    this.choseEmployer = true;
    this.dataService.getEmp(selectedCustomer).subscribe((result: any) => {
      this.employeesList = result;
      // this.employeesList.unshift({ label: "בחר עובדים", value: null });
    });


    // revalidate for Admin
    this.form161FormalyService.getIsForm161AllowedForCustomer(selectedCustomer).subscribe((resultData) => {
      this.isForm161Allowed = resultData;
    },
    (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'תקלה בקבלת פרטי מעסיק');
    });

  };

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({
      severity: type,
      summary: summaryMessage,
      detail: message,
    });
  }

  prevalidate() {
    let minimumDaysForEmployee: number = this.getCustomerMinimumDaysForEmployee;
    if (!minimumDaysForEmployee) {
      this.showMessage('error', '', 'ערך שדה "מספר ימים שהטופס ימתין אצל העובד" לא חוקי');
      return false;
    }
    if(minimumDaysForEmployee<10) {
      this.showMessage('error', '', 'ערך שדה "מספר ימים שהטופס ימתין אצל העובד" חייב להיות לא נמוך מ-10 - רשות המיסים הגדירה זמן מינימום של 10 ימים בהם הטופס צריך להיות אצל העובד');
      return false;
    }
    if(minimumDaysForEmployee>365) {
      this.showMessage('error', '', 'ערך שדה "מספר ימים שהטופס ימתין אצל העובד" חייב להיות לא גבוה מ-365');
      return false;
    }
    return true;
  }

  SubmitSector3 = (employerInfoForm: NgForm) => {

    // prevalidate
    if (!this.prevalidate()) {
      return;
    }

    this.section3StatusClicked = this.enumFormalyStatus.Form161FormalyStatus_Draft;
    // console.log(employerInfoForm.value);

    // this.dataForm161Header =
    let customerData: Form161Header;

    customerData = employerInfoForm.value;

    //console.log(customerData);

    // this.dataForm161Header.TikNikuim = customerData.TikNikuim;
    // this.dataForm161Header.CustomerCityName = customerData.CustomerCityName;
    // this.dataForm161Header.CustomerAddress = customerData.CustomerAddress;
    // this.dataForm161Header.CustomerAddressBuilding = customerData.CustomerAddressBuilding;
    // this.dataForm161Header.CustomerContactPhone = customerData.CustomerContactPhone;
    // this.dataForm161Header.CustomerContactCellPhone = "123123";
    // this.dataForm161Header.CustomerContactMail = customerData.CustomerContactMail;
    // this.dataForm161Header.CustomerSignIdentityNumber = customerData.CustomerSignIdentityNumber;
    // this.dataForm161Header.CustomerSignFirstName = customerData.CustomerSignFirstName;
    // this.dataForm161Header.CustomerSignLastName = customerData.CustomerSignLastName;
    // this.dataForm161Header.CustomerSignCellPhone = customerData.CustomerSignCellPhone;
    // this.dataForm161Header.CustomerSignPhone = customerData.CustomerSignPhone;
    // this.dataForm161Header.CustomerSignMail = customerData.CustomerSignMail;
    // this.dataForm161Header.CustomerZipCode = customerData.CustomerZipCode;
    this.refillCustomerDataFromForm();


    // clean all unchecked employees and FundInstitutions
    let dataToSave: Form161Header = this.clone(this.dataForm161Header);
    dataToSave.Employees = dataToSave.Employees.filter(f=>f.isChecked);
    dataToSave.Employees.forEach(e=> {
      e.FundInstitutions = e.FundInstitutions.filter(f=>f.isChecked);
    });

    this.form161FormalyService
      .createInitialForm(dataToSave, this.section3StatusClicked)
      .subscribe(
        (data) => {
          this.dataForm161Header = data;
        },
        (err: HttpErrorResponse) => {
          this.showMessage("error", "", "תקלה בשמירת טופס");
        }
      );
  };

  checkEmployee(employee: Form161Employee) {
    employee.FundInstitutions.forEach(
      (f) => (f.isChecked = employee.isChecked)
    );
  }

  checkAll() {
    this.dataForm161Header.Employees.forEach((e) => {
      e.isChecked = this.dataForm161Header.isChecked;
      this.checkEmployee(e);
    });
  }

  addFundInstitution() {
    if (this.selectedFundinstitution == null) {
      this.showMessage("error", "", "נא לבחור קופה");
    } else {
      let newFundInstitution: Form161EmployeeFundInstitution =
        new Form161EmployeeFundInstitution();
      let fi = this.fundInstitutionsList.find(
        (f) => f.FundInstitutionId == parseInt(this.selectedFundinstitution)
      );
      newFundInstitution.FundInstitutionId = fi.FundInstitutionId;
      newFundInstitution.Name = fi.Name;
      newFundInstitution.IdentityNumber = fi.IdentityNumber;
      newFundInstitution.IncomeTaxAuthorizationNumber =
        fi.IncomeTaxAuthorizationNumber;
      newFundInstitution.InstitutionName = fi.InstitutionName;
      newFundInstitution.isChecked = true;
      this.currentEmployeeForFundInstitutionAdd.FundInstitutions.push(
        newFundInstitution
      );
      //alert("הקופה נוספה בהצלחה");
      this.dialogAddFundInstitutionVisible = false;
      this.selectedFundinstitution = null;

      if (this.dataForm161Header.FormId && this.dataForm161Header.AllEmployeesInStatusDraft) {

        this.form161FormalyService.addFundInstitutionToExistingForm(newFundInstitution, this.dataForm161Header.FormId, this.currentEmployeeForFundInstitutionAdd.RecordId).subscribe(
          data=>{
            newFundInstitution.RecordFundInstitutionId = data;
            //window.location.href = '/form161Formaly/' + this.dataForm161Header.FormId.toString() + '/' + this.currentEmployeeForFundInstitutionAdd.RecordId.toString();
          }, 
          (err: HttpErrorResponse) => {
            this.showMessage("error", "", "תקלה בהוספת קופה חדשה, נא לרענן את הדף ולנסות מחדש");
          }
        )

      }
    }
  }

  showFundInstitutionDialog(employee: Form161Employee) {
    this.currentEmployeeForFundInstitutionAdd = employee;
    this.dialogAddFundInstitutionVisible = true;
  }

  selectEmployee(employee: Form161Employee) {
    this.selectedRecordId = employee.RecordId;
    this.form161FormalyEmployeeComponent.fillData(employee, this.dataForm161Header);


  }

  selectEmployeeClick(employee: Form161Employee) {
    // this.selectedRecordId = employee.RecordId;
    // this.form161FormalyEmployeeComponent.fillData(employee, this.dataForm161Header);

    window.location.href = '/form161Formaly/' + this.dataForm161Header.FormId.toString() + '/' + employee.RecordId.toString();

  }


  onSaveEmployeeDetails(employee: Form161Employee, actionType: string) {

    if (!this.dataForm161Header.CustomerDataValidated) {

      // prevalidate
      if (!this.prevalidate()) {
        return;
      }
      
      // actually this is first save for 'order' type, all customer data must be validated
      this.refillCustomerDataFromForm();
      if (actionType == 'order' && !this.customerForm.valid) {
        this.showMessage("error", "", "חובה לעדכן באופן תקין את פרטי מעסיק כדי לבצע הזמנה של טופס לעובד");
        return;
      }
    }

    let employeeStatusIdActual: number;
    if (actionType == 'order') {
      employeeStatusIdActual = FormalyStatus.Form161FormalyStatus_OrderedAndWaitingForDataCompletition;
    } else if (actionType == 'draft') {
      employeeStatusIdActual = FormalyStatus.Form161FormalyStatus_Draft;
    } else {
      this.showMessage("error", "", "פעולה לא חוקית");
    }

    let form161SaveContainer: Form161SaveContainer = {
      form161Header: this.dataForm161Header,
      form161EmployeeActual: employee,
      actionType: actionType,
      employeeStatusIdActual: employeeStatusIdActual,
      customerDataIsValid: this.customerForm.valid
    };

    // if (form161SaveContainer.form161Header.Employees && form161SaveContainer.form161Header.Employees.length>0) {
    //   let x = form161SaveContainer.form161Header.Employees[0].WorkPeriodStart;
    //   let y: Date = new Date(x);
    //   console.log(form161SaveContainer.form161Header.Employees[0].WorkPeriodStart);
    //   console.log(y);
    // }

    this.form161FormalyService.saveEmployeeForm(form161SaveContainer)
      .subscribe(
        (data) => {
          let emp: Form161Employee = this.dataForm161Header.Employees.find(f=>f.RecordId==data.RecordId);
          emp = data;
          if (!this.dataForm161Header.CustomerDataValidated && actionType == 'order') {
            //this.dataForm161Header.CustomerDataValidated = true;
          }
          //this.selectEmployee(emp);
          window.location.href = '/form161Formaly/' + this.dataForm161Header.FormId.toString() + '/' + emp.RecordId.toString();



        },
        (err: HttpErrorResponse) => {
          this.showMessage("error", "", "תקלה בשמירת טופס לעובד");
        }
    );
   
  }

  onSaveFunds(employee: Form161Employee) {

    this.form161FormalyService.saveEmployeeFundsAndSendToFormaly(employee)
      .subscribe(
        (data) => {
          let emp: Form161Employee = this.dataForm161Header.Employees.find(f=>f.RecordId==data.RecordId);
          emp = data;
          this.selectEmployee(emp);



        },
        (err: HttpErrorResponse) => {
          this.showMessage("error", "", "תקלה בשמירת טופס לעובד");
        }
    );
   
  }


  removeFundFromEmployee(formId: number, employee: Form161Employee, fundInstitution: Form161EmployeeFundInstitution) {
    this.confirmationService.confirm({
      message: 'האם ברצונך למחוק את הקופה?',
      accept: () => {
          this.form161FormalyService.deleteFundInstitutionToExistingForm(formId, employee.RecordId, fundInstitution.RecordFundInstitutionId).subscribe((result: void) => {
            let index = employee.FundInstitutions.findIndex(f=>f.RecordFundInstitutionId == fundInstitution.RecordFundInstitutionId);
            if (index > -1) {
              employee.FundInstitutions.splice(index, 1);
           }
          }, (err: HttpErrorResponse) => {
            this.showMessage('error', '', 'תקלה במחיקת קופה');
          });
      }
    }); 
  }

  onReload(employee: Form161Employee) {
    window.location.href = '/form161Formaly/' + this.dataForm161Header.FormId.toString() + '/' + employee.RecordId.toString();
  }

  isAllowedToCopy() {
    if (!this.dataForm161Header || !this.dataForm161Header.FormId || !this.dataForm161Header.Employees || this.dataForm161Header.Employees.length == 0) {
      return false;
    }
    let empNotInDraftOrMore = this.dataForm161Header.Employees.filter(f=>!f.FormStatusId || f.FormStatusId<this.enumFormalyStatus.Form161FormalyStatus_Draft);
    if (empNotInDraftOrMore && empNotInDraftOrMore.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  copyForm() {
    this.confirmationService.confirm({
      message: 'האם ברצונך להעתיק את הטופס במלואו?',
      accept: () => {
          this.form161FormalyService.copyForm(this.dataForm161Header.FormId).subscribe((result: Form161Header) => {
            window.location.href = '/form161Formaly/' + result.FormId.toString() + '/' + result.Employees[0].RecordId.toString();
          }, (err: HttpErrorResponse) => {
            this.showMessage('error', '', 'תקלה בהעתקת הטופס');
          });
      }
    }); 
  }

  clone(obj) {
    return JSON.parse(JSON.stringify(obj));
  }



  


}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/form161-formaly/form161-formaly.component.ts